import * as era from '!/era'
import { ui } from '!/skin'
import { Skeleton } from '@/ui/components/Skeleton'
import { useUnit } from 'effector-react'
import { Fragment } from 'react'
import * as homeModel from '../model'
import { LoadMoreRowsTrigger } from './load-more-rows-trigger'
import { Row } from './row'

const INSERT_TRIGGER_N_ITEMS_BEFORE = 2

// banners skin
const bannersSkin = era.skin('routes/home-new/root')

HomePage.displayName = 'HomePage'
export function HomePage(): JSX.Element {
  const [rows, isLoaded, isRowsLoading, isBannersLoading] = useUnit([
    homeModel.$viewRows,
    homeModel.$isRowsLoaded,
    homeModel.$isRowsLoading,
    homeModel.$isBannersLoading,
  ])

  const isContentLoading = (!rows.length && isRowsLoading) || isBannersLoading

  return (
    <ui.PageWrapper>
      <Skeleton pageType='main' isLoading={isContentLoading}>
        <ui.RenderSkin
          from={bannersSkin}
          name='bannersTypeHome'
          key='bannersTypeHome'
        />

        {rows.map((row, i) => {
          const shouldInsertTrigger =
            !isLoaded &&
            rows.length > INSERT_TRIGGER_N_ITEMS_BEFORE &&
            i + 1 === rows.length - INSERT_TRIGGER_N_ITEMS_BEFORE

          return (
            <Fragment key={row.id}>
              <Row id={row.id} />
              {shouldInsertTrigger && <LoadMoreRowsTrigger />}
            </Fragment>
          )
        })}
      </Skeleton>
    </ui.PageWrapper>
  )
}
